/** Halloween theme stage (Copenhagen time), every year: 0 off, 1 Oct 1–10, 2 Oct 11–20, 3 Oct 21–30, 4 Oct 31 before 18:00, 5 Halloween Night (Oct 31 18:00 – Nov 1 06:00). */
export function creepyStage(now: Date = new Date()): number {
  const p = Object.fromEntries(
    new Intl.DateTimeFormat("en-GB", { timeZone: "Europe/Copenhagen", month: "numeric", day: "numeric", hour: "numeric", hourCycle: "h23" })
      .formatToParts(now).map((x) => [x.type, Number(x.value)]),
  ) as Record<string, number>;
  const { month, day, hour } = p;
  if (month === 11 && day === 1 && hour < 6) return 5;
  if (month !== 10) return 0;
  if (day === 31) return hour >= 18 ? 5 : 4;
  if (day >= 21) return 3;
  if (day >= 11) return 2;
  return 1;
}
